import styled from 'styled-components';

export const SPage = styled.div`
  text-align: center;
  padding: 48px 20px 65px;
  background-color: transparent;

  .ant-alert {
    margin-top: -44px;
    margin-bottom: 6px;
  }

  .verification-code-wrapper {
    width: fit-content;
    margin: 0 auto 24px;
  }
`;
